import { useState } from "react";
import { supabase } from "@/libs/supabase";
import { useAuth } from "../useAuth";

interface CreateCommentParams {
	postId: string;
	content: string;
}

export const useCreateComment = () => {
	const [loading, setLoading] = useState(false);
	const { user } = useAuth();

	const createComment = async ({ postId, content }: CreateCommentParams) => {
		if (!user) throw new Error("認証が必要です");

		setLoading(true);
		try {
			const { data, error } = await supabase
				.from("comments")
				.insert([
					{
						post_id: postId,
						user_id: user.id,
						content,
					},
				])
				.select("*, user:users(*)");

			if (error) throw error;
			return data[0];
		} finally {
			setLoading(false);
		}
	};

	return { createComment, loading };
};
